import { render, staticRenderFns } from "./CustomPeriodPicker.vue?vue&type=template&id=b4629984&scoped=true"
import script from "./CustomPeriodPicker.vue?vue&type=script&lang=ts"
export * from "./CustomPeriodPicker.vue?vue&type=script&lang=ts"
import style0 from "./CustomPeriodPicker.vue?vue&type=style&index=0&id=b4629984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4629984",
  null
  
)

export default component.exports